import _u from '../util';

export const CALCULATORS = [
    {
        'userHpId': '2',
        'name': 'CALCULATORS FOR CARDIOLOGISTS',
        'urls': [
            { title: 'TIMI Score for STEMI', url: 'https://reference.' + _u.getDomain(true) + 'medscape.com/calculator/thrombolysis-myocardial-infarction-timi-st' },
            { title: 'TIMI Score for UA/NSTEMI', url: 'https://reference.' + _u.getDomain(true) + 'medscape.com/calculator/thrombolysis-myocardial-infarction-timi-unstable' },
            { title: 'AFib CHA2DS2-VASc Score', url: 'https://reference.' + _u.getDomain(true) + 'medscape.com/calculator/chads-vasc-af-stroke' },
        ],
        'view_button': 'https://reference.' + _u.getDomain(true) + 'medscape.com/guide/medical-calculators#heart_and_chest',
    }, {
        'userHpId': '34',
        'name': 'CALCULATORS FOR FAMILY PHYSICIANS',
        'urls': [
            { title: 'BMI and BSA (Mosteller)', url: 'https://reference.' + _u.getDomain(true) + 'medscape.com/calculator/28/bmi-and-bsa-mosteller' },
            { title: 'Due Date by LMP', url: 'https://reference.' + _u.getDomain(true) + 'medscape.com/calculator/240/due-date-by-lmp' },
            { title: 'Weight-based medication dosing', url: 'https://reference.' + _u.getDomain(true) + 'medscape.com/calculator/650/weight-based-medication-dosing' },
        ],
        'view_button': 'https://reference.' + _u.getDomain(true) + 'medscape.com/guide/medical-calculators',
    }, {
        'userHpId': '50',
        'name': 'CALCULATORS FOR HOSPITALIST',
        'urls': [
            { title: 'Anion Gap', url: 'https://reference.' + _u.getDomain(true) + 'medscape.com/calculator/11/anion-gap' },
            { title: 'Maintenance Fluid Calculations', url: 'https://reference.' + _u.getDomain(true) + 'medscape.com/calculator/526/maintenance-fluid-calculations' },
            { title: 'Sodium Correction Rate for Hyponatremia', url: 'https://reference.' + _u.getDomain(true) + 'medscape.com/calculator/643/sodium-correction-rate-for-hyponatremia' },
        ],
        'view_button': 'https://reference.' + _u.getDomain(true) + 'medscape.com/guide/medical-calculators',
    }, {
        'userHpId': '18',
        'name': 'CALCULATORS FOR INTERNISTS',
        'urls': [
            { title: 'ACC/AHA CV Risk Calculator (2013)', url: 'https://reference.' + _u.getDomain(true) + 'medscape.com/calculator/37/acc-aha-cv-risk-calculator-2013' },
            { title: 'DVT Clinical Probability (Well\'s)', url: 'https://reference.' + _u.getDomain(true) + 'medscape.com/calculator/dvt-probability-wells-score' },
            { title: 'Pneumonia risk (CURB-65)', url: 'https://reference.' + _u.getDomain(true) + 'medscape.com/calculator/188/pneumonia-risk-curb-65' },
        ],
        'view_button': 'https://reference.' + _u.getDomain(true) + 'medscape.com/guide/medical-calculators',
    }, {
        'userHpId': '38',
        'name': 'CALCULATORS FOR ALLERGISTS',
        'urls': [
            { title: 'TB Skin Test Interpretation', url: 'https://reference.' + _u.getDomain(true) + 'medscape.com/calculator/520/tb-skin-test-interpretation' },
        ],
        'view_button': 'https://reference.' + _u.getDomain(true) + 'medscape.com/guide/medical-calculators',
    }, {
        'userHpId': '46',
        'name': 'CALCULATORS FOR ANESTHESIOLOGISTS',
        'urls': [
            { title: 'ASA Physical Status', url: 'https://reference.' + _u.getDomain(true) + 'medscape.com/calculator/589/asa-physical-status' },
            { title: 'Cardiac Output - Fick', url: 'https://reference.' + _u.getDomain(true) + 'medscape.com/calculator/111/cardiac-output-fick' },
            { title: 'STOP-BANG Score for Obstructive Sleep Apnea', url: 'https://reference.' + _u.getDomain(true) + 'medscape.com/calculator/531/stop-bang-score-for-obstructive-sleep-apnea' },
        ],
        'view_button': 'https://reference.' + _u.getDomain(true) + 'medscape.com/guide/medical-calculators',
    }, {
        'userHpId': '32',
        'name': 'CALCULATORS FOR CRITICAL CARE SPECIALISTS',
        'urls': [
            { title: 'Child-Pugh Score', url: 'https://reference.' + _u.getDomain(true) + 'medscape.com/calculator/43/child-pugh-score' },
            { title: 'Glasgow Coma Score (GCS)', url: 'https://reference.' + _u.getDomain(true) + 'medscape.com/calculator/101/glasgow-coma-scale-gcs' },
            { title: 'Sequential Organ Failure Assessment (SOFA)', url: 'https://reference.' + _u.getDomain(true) + 'medscape.com/calculator/268/sequential-organ-failure-assessment-sofa' },
        ],
        'view_button': 'https://reference.' + _u.getDomain(true) + 'medscape.com/guide/medical-calculators',
    }, {
        'userHpId': '33',
        'name': 'CALCULATORS FOR DERMATOLOGISTS',
        'urls': [
            { title: 'TB Skin Test Interpretation', url: 'https://reference.' + _u.getDomain(true) + 'medscape.com/calculator/520/tb-skin-test-interpretation' },
        ],
        'view_button': 'https://reference.' + _u.getDomain(true) + 'medscape.com/guide/medical-calculators',
    }, {
        'userHpId': '22',
        'name': 'CALCULATORS FOR DIABETOLOGISTS & ENDOCRINOLOGISTS',
        'urls': [
            { title: 'Diabetes Risk Score (Type 2)', url: 'https://reference.' + _u.getDomain(true) + 'medscape.com/calculator/675/diabetes-risk-score-type-2' },
            { title: 'Dubbo Osteoporotic Fracture Risk', url: 'https://reference.' + _u.getDomain(true) + 'medscape.com/calculator/66/dubbo-osteoporotic-fracture-risk' },
            { title: 'Lipid Lowering Guidelines Using Framingham (2008)', url: 'https://reference.' + _u.getDomain(true) + 'medscape.com/calculator/98/lipid-lowering-guidelines-using-framingham-2008' },
        ],
        'view_button': 'https://reference.' + _u.getDomain(true) + 'medscape.com/guide/medical-calculators',
    }, {
        'userHpId': '20',
        'name': 'CALCULATORS FOR GASTROENTEROLOGISTS',
        'urls': [
            { title: 'APACHE II', url: 'https://reference.' + _u.getDomain(true) + 'medscape.com/calculator/12/apache-ii' },
            { title: 'Child-Pugh Score', url: 'https://reference.' + _u.getDomain(true) + 'medscape.com/calculator/43/child-pugh-score' },
            { title: 'Crohn\'s Disease Activity Index (CDAI)', url: 'https://reference.' + _u.getDomain(true) + 'medscape.com/calculator/337/crohn-s-disease-activity-index-cdai' },
        ],
        'view_button': 'https://reference.' + _u.getDomain(true) + 'medscape.com/guide/medical-calculators',
    }, {
        'userHpId': '14',
        'name': 'CALCULATORS FOR SURGEONS',
        'urls': [
            { title: 'cTNM Staging for Breast Cancer (AJCC 2017)', url: 'https://reference.' + _u.getDomain(true) + 'medscape.com/calculator/586/ctnm-staging-for-breast-cancer-ajcc-2017' },
            { title: 'Injury Severity Score', url: 'https://reference.' + _u.getDomain(true) + 'medscape.com/calculator/356/injury-severity-score' },
            { title: 'Surgical Apgar Score', url: 'https://reference.' + _u.getDomain(true) + 'medscape.com/calculator/280/surgical-apgar-score' },
        ],
        'view_button': 'https://reference.' + _u.getDomain(true) + 'medscape.com/guide/medical-calculators',
    }, {
        'userHpId': '26',
        'name': 'CALCULATORS FOR NEUROLOGISTS',
        'urls': [
            { title: 'Glasgow Outcome Scale Extended [GOS-E]', url: 'https://reference.' + _u.getDomain(true) + 'medscape.com/calculator/721/glasgow-outcome-scale-extended-gos-e' },
            { title: 'Multiple Sclerosis: Diagnosis', url: 'https://reference.' + _u.getDomain(true) + 'medscape.com/calculator/482/multiple-sclerosis-diagnosis' },
            { title: 'NIH Stroke Scale/Score (NIHSS)', url: 'https://reference.' + _u.getDomain(true) + 'medscape.com/calculator/273/nih-stroke-scale-score-nihss' },
        ],
        'view_button': 'https://reference.' + _u.getDomain(true) + 'medscape.com/guide/medical-calculators',
    }, {
        'userHpId': '16',
        'name': 'CALCULATORS FOR OBSTETRICIANS & GYNECOLOGISTS',
        'urls': [
            { title: 'Bishop Score', url: 'https://reference.' + _u.getDomain(true) + 'medscape.com/calculator/24/bishop-score' },
            { title: 'Due Date by LMP', url: 'https://reference.' + _u.getDomain(true) + 'medscape.com/calculator/240/due-date-by-lmp' },
            { title: 'Pregnancy Gestation by LMP and Ultrasound Biometry', url: 'https://reference.' + _u.getDomain(true) + 'medscape.com/calculator/697/pregnancy-gestation-by-lmp-and-ultrasound-biometry' },
        ],
        'view_button': 'https://reference.' + _u.getDomain(true) + 'medscape.com/guide/medical-calculators',
    }, {
        'userHpId': '7',
        'name': 'CALCULATORS FOR ONCOLOGISTS',
        'urls': [
            { title: 'Absolute Neutrophil Count (ANC)', url: 'https://reference.' + _u.getDomain(true) + 'medscape.com/calculator/641/absolute-neutrophil-count-anc' },
            { title: 'Body Surface Area Based Dosing', url: 'https://reference.' + _u.getDomain(true) + 'medscape.com/calculator/692/body-surface-area-based-dosing' },
            { title: 'Carboplatin AUC Dosing (Calvert)', url: 'https://reference.' + _u.getDomain(true) + 'medscape.com/calculator/169/carboplatin-auc-dosing-calvert' },
        ],
        'view_button': 'https://reference.' + _u.getDomain(true) + 'medscape.com/guide/medical-calculators',
    }, {
        'userHpId': '43',
        'name': 'CALCULATORS FOR PATHOLOGISTS',
        'urls': [
            { title: 'Calcium Correction for Hypoalbuminemia', url: 'https://reference.' + _u.getDomain(true) + 'medscape.com/calculator/267/calcium-correction-for-hypoalbuminemia' },
            { title: 'eGFR using CKD-EPI', url: 'https://reference.' + _u.getDomain(true) + 'medscape.com/calculator/251/egfr-using-ckd-epi' },
            { title: 'Glomerulosclerosis on Biopsy (2015)', url: 'https://reference.' + _u.getDomain(true) + 'medscape.com/calculator/2/glomerulosclerosis-on-biopsy-2015' },
        ],
        'view_button': 'https://reference.' + _u.getDomain(true) + 'medscape.com/guide/medical-calculators',
    }, {
        'userHpId': '9',
        'name': 'CALCULATORS FOR PEDIATRICIANS',
        'urls': [
            { title: 'APGAR', url: 'https://reference.' + _u.getDomain(true) + 'medscape.com/calculator/13/apgar' },
            { title: 'Centor Score (modified) for GAS Pharyngitis', url: 'https://reference.' + _u.getDomain(true) + 'medscape.com/calculator/489/centor-score-modified-for-gas-pharyngitis' },
            { title: 'PRAM Score for Pediatric Asthma Exacerbation Severity', url: 'https://reference.' + _u.getDomain(true) + 'medscape.com/calculator/534/pram-score-for-pediatric-asthma-exacerbation-severity' },
        ],
        'view_button': 'https://reference.' + _u.getDomain(true) + 'medscape.com/guide/medical-calculators',
    }, {
        'userHpId': '48',
        'name': 'CALCULATORS FOR PLASTIC SURGEONS',
        'urls': [
            { title: 'Before Induction of Anaesthesia', url: 'https://reference.' + _u.getDomain(true) + 'medscape.com/calculator/226/before-induction-of-anaesthesia' },
            { title: 'BMI and BSA (Du Bois)', url: 'https://reference.' + _u.getDomain(true) + 'medscape.com/calculator/30/bmi-and-bsa-du-bois' },
            { title: 'Patient Health Questionnaire-9 (PHQ-9)', url: 'https://reference.' + _u.getDomain(true) + 'medscape.com/calculator/271/patient-health-questionnaire-9-phq-9' },
        ],
        'view_button': 'https://reference.' + _u.getDomain(true) + 'medscape.com/guide/medical-calculators',
    }, {
        'userHpId': '12',
        'name': 'CALCULATORS FOR PSYCHIATRISTS',
        'urls': [
            { title: 'Eating Disorder Diagnostic Scale (EDDS)', url: 'https://reference.' + _u.getDomain(true) + 'medscape.com/calculator/562/eating-disorder-diagnostic-scale-edds' },
            { title: 'Generalized Anxiety Disorder 2 (GAD-2)', url: 'https://reference.' + _u.getDomain(true) + 'medscape.com/calculator/570/generalized-anxiety-disorder-2-gad-2' },
            { title: 'Major Depression Inventory', url: 'https://reference.' + _u.getDomain(true) + 'medscape.com/calculator/542/major-depression-inventory-mdi' },
        ],
        'view_button': 'https://reference.' + _u.getDomain(true) + 'medscape.com/guide/medical-calculators',
    }, {
        'userHpId': '13',
        'name': 'CALCULATORS FOR PULMONOLOGISTS',
        'urls': [
            { title: 'DVT Clinical Probability (Well\'s)', url: 'https://reference.' + _u.getDomain(true) + 'medscape.com/calculator/69/dvt-clinical-probability-well-s' },
            { title: 'PaO₂:FiO₂ Ratio', url: 'https://reference.' + _u.getDomain(true) + 'medscape.com/calculator/174/pao-fio-ratio' },
            { title: 'Solitary Pulmonary Nodule Malignancy Risk', url: 'https://reference.' + _u.getDomain(true) + 'medscape.com/calculator/4/solitary-pulmonary-nodule-malignancy-risk' },
        ],
        'view_button': 'https://reference.' + _u.getDomain(true) + 'medscape.com/guide/medical-calculators',
    }, {
        'userHpId': '35',
        'name': 'CALCULATORS FOR RADIOLOGISTS',
        'urls': [
            { title: 'CT Severity Index (Pancreatitis)', url: 'https://reference.' + _u.getDomain(true) + 'medscape.com/calculator/54/ct-severity-index-pancreatitis' },
            { title: 'Due Date by Ultrasound', url: 'https://reference.' + _u.getDomain(true) + 'medscape.com/calculator/241/due-date-by-ultrasound' },
            { title: 'Canadian Head CT Rule', url: 'https://reference.' + _u.getDomain(true) + 'medscape.com/calculator/33/canadian-ct-head-rule' },
        ],
        'view_button': 'https://reference.' + _u.getDomain(true) + 'medscape.com/guide/medical-calculators',
    }, {
        'userHpId': '27',
        'name': 'CALCULATORS FOR RHEUMATOLOGISTS',
        'urls': [
            { title: 'Clinical Disease Activity Index for RA (CDAI)', url: 'https://reference.' + _u.getDomain(true) + 'medscape.com/calculator/279/clinical-disease-activity-index-for-ra-cdai' },
            { title: 'Polymyalgia Rheumatica (2012 EULAR/ACR Provisional Criteria)', url: 'https://reference.' + _u.getDomain(true) + 'medscape.com/calculator/318/polymyalgia-rheumatica-2012-eular-acr-provisional-criteria' },
            { title: 'SLICC SLE Criteria', url: 'https://reference.' + _u.getDomain(true) + 'medscape.com/calculator/274/slicc-sle-criteria' },
        ],
        'view_button': 'https://reference.' + _u.getDomain(true) + 'medscape.com/guide/medical-calculators',
    }, {
        'userHpId': '15',
        'name': 'CALCULATORS FOR UROLOGISTS',
        'urls': [
            { title: 'International Index of Erectile Function (IIEF-5)', url: 'https://reference.' + _u.getDomain(true) + 'medscape.com/calculator/377/international-index-of-erectile-function-iief-5' },
            { title: 'International Prostate Symptom Score (IPSS)', url: 'https://reference.' + _u.getDomain(true) + 'medscape.com/calculator/338/international-prostate-symptom-score-ipss' },
            { title: 'ROKS – Recurrence Of Kidney Stone (2018)', url: 'https://reference.' + _u.getDomain(true) + 'medscape.com/calculator/438/roks-recurrence-of-kidney-stone-2018' },
        ],
        'view_button': 'https://reference.' + _u.getDomain(true) + 'medscape.com/guide/medical-calculators',
    }, {
        'userHpId': '30',
        'name': 'CALCULATORS FOR PHARMACISTS',
        'urls': [
            { title: 'Body Surface Area Based Dosing', url: 'https://reference.' + _u.getDomain(true) + 'medscape.com/calculator/692/body-surface-area-based-dosing' },
            { title: 'IV Drip Rate Calculator', url: 'https://reference.' + _u.getDomain(true) + 'medscape.com/calculator/644/iv-drip-rate-calculator' },
            { title: 'Weight-Based Medication Dosing', url: 'https://reference.' + _u.getDomain(true) + 'medscape.com/calculator/650/weight-based-medication-dosing' },
        ],
        'view_button': 'https://reference.' + _u.getDomain(true) + 'medscape.com/guide/medical-calculators',
    }, {
        'userHpId': '29',
        'name': 'CALCULATORS FOR TRANSPLANTATION',
        'urls': [
            { title: 'ESRD Risk Tool for Kidney Donor Candidates', url: 'https://reference.' + _u.getDomain(true) + 'medscape.com/calculator/622/esrd-risk-tool-for-kidney-donor-candidates' },
            { title: 'Predicted Heart Mass Calculator (PHM)', url: 'https://reference.' + _u.getDomain(true) + 'medscape.com/calculator/654/predicted-heart-mass-calculator-phm' },
            { title: 'UKELD Score', url: 'https://reference.' + _u.getDomain(true) + 'medscape.com/calculator/442/ukeld-score' },
        ],
        'view_button': 'https://reference.' + _u.getDomain(true) + 'medscape.com/guide/medical-calculators',
    },  {
        'userHpId': '44',
        'name': 'CALCULATORS FOR NEPHROLOGISTS',
        'urls': [
            { title: 'Anion Gap', url: 'https://reference.' + _u.getDomain(true) + 'medscape.com/calculator/11/anion-gap' },
            { title: 'APACHE II', url: 'https://reference.' + _u.getDomain(true) + 'medscape.com/calculator/12/apache-ii' },
            { title: 'eGFR using CKD-EPI', url: 'https://reference.' + _u.getDomain(true) + 'medscape.com/calculator/251/egfr-using-ckd-epi' },
        ],
        'view_button': 'https://reference.' + _u.getDomain(true) + 'medscape.com/guide/medical-calculators',
    },
]